import { CountryIso3Code } from '@domgen/dgx-fe-i18n';
import { CustomerAddressDetails } from '../../models/customer/customer-address-details.interface';

export const mockCustomerAddressDetails: CustomerAddressDetails = {
  line1: '123 Fairwater House',
  line2: '3 Bonnet Street',
  city: 'London',
  state: 'CA',
  country: CountryIso3Code.UnitedStates,
  postalCode: 'E16 2SZ',
};
